import { all, call, put, takeLatest } from "redux-saga/effects";
import {
    fetchPopupFailure,
    fetchPopupRequest,
    fetchPopupSuccess
} from './action'
import { 
    FETCH_ACTIVE_POPUP_REQUEST,
    FETCH_POPUP_REQUEST,
    FETCH_PUBLISH_POPUP_REQUEST,
    FETCH_CREATE_NEW_POPUP_REQUEST,
    FETCH_POPUP_ID_REQUEST
} from './actionTypes';
import baseApi from "./api";
function * fetchPopupIdSaga({params}:any):any{
    try{
        const res = yield call(
            baseApi.fetchPopupId,
            params || {}
        )
        yield put( 
            fetchPopupSuccess({
                popUp: res,
                popupInfo: res.data[0]
            })
        )
    } catch(err){
            fetchPopupFailure({
                error: ''
            })
    }
}
function * fetchCreateNewPopupSaga({body}:any):any{
    try {
        const res = yield call(
            baseApi.fetchCreateNewPopup, body
        )
        console.log(res)
    } catch (error) {
        fetchPopupFailure({
            error: ''
        })
    }
}
function * fetchPopupActiveSaga({id}:any):any{
    try {  
        const res = yield call(
            baseApi.fetchActivePopup, id
        )
        if(res.status ==='delete multi success'){
            yield put(fetchPopupRequest({})) 
        }
    } catch (error) {
        fetchPopupFailure({
            error: ''
        })
    }
}
function * fetchPopupPublishSaga({params}:any):any{
    try {  
        const res = yield call(
            baseApi.fetchPublishPopup, params
        )
        console.log(res)
        if(res.status ==="Change status success"){
            yield put(fetchPopupRequest({})) 
        }
    } catch (error) {
        fetchPopupFailure({
            error: ''
        })
    }
}
function* fetchPopupSaga({params}:any):any{
    try{
        const res = yield call(
            baseApi.fetchPopupList,
            params || {}
        )
        yield put( 
            fetchPopupSuccess({
                popUp: res.data,
                popupInfo: {}

            })
        )
    } catch(err){
            fetchPopupFailure({
                error: ''
            })
    }
}
function* toPopupSaga(){
    yield all([takeLatest(FETCH_POPUP_REQUEST, fetchPopupSaga)]);
    yield all([takeLatest(FETCH_ACTIVE_POPUP_REQUEST, fetchPopupActiveSaga)]);
    yield all([takeLatest(FETCH_PUBLISH_POPUP_REQUEST, fetchPopupPublishSaga)]);
    yield all([takeLatest(FETCH_CREATE_NEW_POPUP_REQUEST, fetchCreateNewPopupSaga)]);
    yield all([takeLatest(FETCH_POPUP_ID_REQUEST, fetchPopupIdSaga)]);
}
export default toPopupSaga;